import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import MapIcon from "@mui/icons-material/Map";
import { useTranslation } from "react-i18next";
import {
  CircularProgress,
  Divider,
  Paper,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { Confirm } from "notiflix";
import CloseIcon from "@mui/icons-material/Close";
import AppContext from "../../../../Contexts/AppContext";
import ClearIcon from "@mui/icons-material/Clear";
import {
  changeCategory,
  getCarbonDailyQuotes,
  getCarbonHourlyQuotes,
  getCarbonQuotes,
  processArea,
  processAreaSpain,
  processAreaPortugal,
} from "../../../../../api/ApiCarbonSink";
import EuroIcon from "@mui/icons-material/Euro";
import {
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
  Tooltip as MUITooltip,
} from "@mui/material";
import Co2Icon from "@mui/icons-material/Co2";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  ArcElement,
  Title,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
} from "chart.js";
import { Radar, Pie, PolarArea, Line, Scatter } from "react-chartjs-2";
import { m } from "framer-motion";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { toast } from "react-toastify";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { resetDrawingSession } from "../../../../../services/MapCore/MapService";
import ForestIcon from "@mui/icons-material/Forest";
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  ArcElement,
  Title,
  CategoryScale,
  LinearScale,
  LogarithmicScale
);

const units = {
  area_ha: "ha",
  area_km2: "km²",
  area_m2: "m²",
  carbon_credits_diff_tCO2e_km2: "tCO₂e/km²",
  carbon_credits_difference_tCO2e: "tCO₂e",
  carbon_credits_tCO2e_per_km2: "tCO₂e/km²",
  carbon_credits_tCO2e: "tCO₂e",
  carbon_diff_Mg_per_km2: "mg/km²",
  carbon_Mg_per_km2: "Mg/km²",
  carbon_Mg: "Mg",
  market_value_diff_euros_per_km2: "€/km²",
  market_value_difference_euros: "€",
  market_value_euros_per_km2: "€/km²",
  market_value_euros_per_m2: "€/m²",
  market_value_euros: "€",
  new_land_cover_Mg_per_km2: "Mg/km²",
  // carbon_quote: "€/CC",
  actual_carbon_quote: "€/CC",
};

export const CarbonFeatureFormSp = forwardRef(({ onClose }, ref) => {
  // console.log("FeatureForm content", content, content[0]?.view?.[0]);
  const {
    // mapInstanceRef,
    editedGeometry,
    setEditedGeometry,
    layersGroupsRef,
    modeOptions,
    carbonResponse,
    setCarbonResponse,
    actualGroundUse,
    setActualGroundUse,
    carbonCategoryRef,
    mapInstanceRef,
    project,
  } = useContext(AppContext);

  console.log("layersGroupsRef", layersGroupsRef?.current);
  const { t, i18n } = useTranslation("main");

  const [areaUnit, setAreaUnit] = useState("%");
  // const [areaUnit, setAreaUnit] = useState("m2");
  const [carbonQuotes, setCarbonQuotes] = useState();
  // const handleChangeAreaUnit = (event, newAlignment) => {
  //   if (!newAlignment) return;
  //   setAreaUnit(newAlignment);
  // };

  const categoriesColors_raw = {
    CARBON_SINK: {
      // "Sin datos": null,
      "Cobertura arbórea": "#31a354",
      Matorral: "#addd8e",
      Pastizales: null,
      "Tierras de cultivo": "#fd8d3c",
      "Área urbanizada": "#e34a33",
      "Vegetación escasa o desnuda": "#fef0d9",
      "Cuerpos de agua permanentes": "#3182bd",
      "Humedales herbáceos": "#7fcdbb",
      Manglares: null,
      "Musgos y líquenes": null,
    },
    CARBON_SINK_PT: {
      // PT
      "Agricultura com espaços naturais e seminaturais": "#97d856",
      "Agricultura protegida e viveiros": "#8ad856",
      "Albufeiras de barragens": "#5697d8",
      "Áreas em construção": "#d85656",
      Aterros: "#d8b856",
      Comércio: "#d86156",
      "Culturas temporárias de sequeiro e regadio": "#7dd856",
      "Cursos de água naturais": "#5684d8",
      "Equipamentos culturais": "#568ad8",
      "Equipamentos de lazer": "#5663d8",
      "Florestas de castanheiro": "#56d856",
      "Florestas de espécies invasoras": "#56d85e",
      "Florestas de eucalipto": "#56d866",
      "Florestas de outras folhosas": "#56d86e",
      "Florestas de outras resinosas": "#56d875",
      "Florestas de outros carvalhos": "#56d87d",
      "Florestas de pinheiro bravo": "#56d885",
      "Florestas de sobreiro": "#56d88d",
      Indústria: "#d87665",
      "Infraestruturas de produção de energia renovável": "#be92dd",
      "Infraestruturas de tratamento de resíduos e águas residuais": "#5670d8",
      "Infraestruturas para captação, tratamento e abastecimento de águas para consumo":
        "#565dd8",
      "Instalações agrícolas": "#dcab54",
      "Instalações desportivas": "#dca48d",
      "Lixeiras e Sucatas": "#d8d256",
      Matos: "#56d895",
      "Mosaicos culturais e parcelares complexos": "#d8c356",
      Olivais: "#70d856",
      "Outros equipamentos e instalações turísticas": "#dcc17a",
      "Parques e jardins": "#56d882",
      "Pastagens espontâneas": "#82d856",
      "Pastagens melhoradas": "#5bd856",
      Pedreiras: "#c5d856",
      Pomares: "#63d856",
      "Rede viária e espaços associados": "#a4a4a4",
      "Tecido edificado contínuo predominantemente horizontal": "#d87856",
      "Tecido edificado contínuo predominantemente vertical": "#d88356",
      "Tecido edificado descontínuo": "#d88e56",
      "Tecido edificado descontínuo esparso": "#d89956",
      "Vegetação esparsa": "#56d89c",
      Vinhas: "#56d8b4",
    },
    // SP
    // Arbolado: "#d148fa",
    // "Balsas y estanques": "#38df38",
    // "Caminos y sendas": "#94bc94",
    // Carreteras: "#eec21f",
    // "Coberturas de agua": "#37d3dc",
    // Coníferas: "#d7e8bb",
    // "Construcción deportiva": "#8d910a",
    // Cultivos: "#af378d",
    // "Cultivos herbáceos": "#aca0d9",
    // "Cursos de agua": "#dc602f",
    // Desconocido: "#4af5f4",
    // Edificación: "#9f9053",
    // Embalses: "#8d494e",
    // "Frondosas caducifolias": "#c7a4e6",
    // "Frondosas perennifolias": "#12b3ba",
    // "Frutales no cítricos": "#09d933",
    // Huerta: "#7b3c29",
    // "Otras construcciones": "#8de71c",
    // Pastizal: "#b07a24",
    // "Pastizal-matorral": "#029890",
    // "Pasto arbolado": "#b9f6dc",
    // Piscina: "#39a40e",
    // Prados: "#cb9dec",
    // "Red de transporte terrestre sin catalogar": "#fa51b4",
    // "Suelo no edificado": "#e8b704",
    // "Terrenos con escasa o nula vegetación": "#5b6d32",
    // "Vías urbanas": "#030cdc",
    // Viñedo: "#5be2ae",
    // "Zona abierta": "#294119",
    // "Zonas de extracción": "#b9d843",
    // "Zonas de vertido": "#51ec68",
    // "Zonas pavimentadas o selladas": "#947d76",
    // "Zona verde artificial y arbolado urbano": "#867dea",
    CARBON_SINK_SP: {
      "Abedul pubescens (Betula alba)": "#3cb371",
      "Acebo (Ilex aquifolium)": "#8b4513",
      "Agrícola con arbolado": "#ffffe0",
      "Aliso (Alnus glutinosa)": "#dc143c",
      Arbolado: "#d148fa",
      "Arce seudoplátano (Acer pseudoplatanus)": "#a9a9a9",
      "Avellano (Corylus avellana)": "#ff0000",
      "Balsas y estanques": "#38df38",
      "Bardaguera (Salix atrocinerea)": "#e6e6fa",
      "Caminos y sendas": "#94bc94",
      Carreteras: "#eec21f",
      "Castaño (Castanea sativa)": "#4b0082",
      "Coberturas de agua": "#37d3dc",
      "Construcción deportiva": "#8d910a",
      Coníferas: "#d7e8bb",
      "Coníferas genéricas": "#dda0dd",
      Cultivos: "#af378d",
      "Cultivos herbáceos": "#aca0d9",
      "Cursos de agua": "#dc602f",
      Desconocido: "#4af5f4",
      Edificación: "#9f9053",
      Embalses: "#8d494e",
      "Eucalipto globulus (Eucalyptus globulus)": "#d8bfd8",
      "Eucalipto nitens (Eucalyptus nitens)": "#e9967a",
      "Fresno excelsior (Fraxinus excelsior)": "#b8860b",
      "Frondosas caducifolias": "#c7a4e6",
      "Frondosas genéricas": "#faf0e6",
      "Frondosas perennifolias": "#12b3ba",
      "Frutales no cítricos": "#09d933",
      "Haya (Fagus sylvatica)": "#00ffff",
      Huerta: "#7b3c29",
      "Madroño (Arbutus unedo )": "#b0c4de",
      Matorral: "#800000",
      "Otras construcciones": "#8de71c",
      Pastizal: "#a9a9a9",
      "Pastizal-matorral": "#029890",
      "Pasto arbolado": "#b9f6dc",
      "Peral silvestre (Pyrus spp.": "#00ffff",
      "Pino pináster (Pinus pinaster)": "#000080",
      "Pino radiata (Pinus radiata)": "#191970",
      "Pino silvestre (Pinus sylvestris)": "#483d8b",
      Piscina: "#39a40e",
      Prados: "#cb9dec",
      "Rebollo (Quercus pyrenaica)": "#ffffff",
      "Red de transporte terrestre sin catalogar": "#fa51b4",
      "Roble (Quercus petraea)": "#ba55d3",
      "Roble pedunculado (Quercus robur)": "#ffefd5",
      "Serbal de cazadores (Sorbus aucuparia)": "#f5f5dc",
      "Seudotsuga (Pseudotsuga menziesii)": "#daa520",
      "Suelo no edificado": "#e8b704",
      "Terrenos con escasa o nula vegetación": "#5b6d32",
      Viñedo: "#5be2ae",
      "Vías urbanas": "#030cdc",
      "Zona abierta": "#294119",
      "Zona verde artificial y arbolado urbano": "#867dea",
      "Zonas de extracción": "#b9d843",
      "Zonas de vertido": "#51ec68",
      "Zonas pavimentadas o selladas": "#947d76",
    },
  };
  const categoriesColors =
    { ...categoriesColors_raw[project?.category], "Sin datos": null } || {};
  // const initialCategory = Object.keys(categoriesColors)[0];
  const initialCategory = "Sin datos";

  const [category, setCategory] = useState(initialCategory);
  // const [response, setResponse] = useState({});
  // const [actualGroundUse, setActualGroundUse] = useState({});
  // console.log("actualGroundUse", actualGroundUse);
  const [isLoading, setIsLoading] = useState(false);

  // const [showMore, setShowMore] = useState({
  //   area: true,
  //   market_value: true,
  //   carbon_credits: true,
  // });

  // const toggleSection = (section) => {
  //   setShowMore((prev) => ({
  //     ...prev,
  //     [section]: !prev[section],
  //   }));
  // };

  // const getMaxHeight = (section) => (showMore[section] ? "300px" : "0px");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getCarbonDailyQuotes();
        // getCarbonHourlyQuotes();
        console.log("carbon quotes", res);
        setCarbonQuotes(
          res
            .sort((a, b) => new Date(b.fx_value) - new Date(a.fx_value)) // orden descendente (más nuevo primero)
            .slice(0, 30) // tomamos los 30 más recientes
            .sort((a, b) => new Date(a.fx_value) - new Date(b.fx_value)) // los reordenamos de más antiguo a más nuevo
        );
      } catch (error) {
        console.error("Error al cargar los valores de carbono:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    // console.log("editedGeometry", editedGeometry);
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const geometry = {
          coordinates: editedGeometry,
          type: "Polygon",
          // type: "MultiPolygon",
        };
        const services = {
          CARBON_SINK: processArea,
          CARBON_SINK_SP: processAreaSpain,
          CARBON_SINK_PT: processAreaPortugal,
        };
        const res = await services[project?.category](
          modeOptions.CARBON_SINK[0],
          geometry
        );
        // console.log("RESPONSE PORTUGALLLLL", typeof res);
        // console.log(
        //   "RESPONSE PORTUGAL 1",
        //   res["Florestas de outros carvalhos"]
        //   // [
        //   //   "Absorción acumulada total (tCO₂)"
        //   // ]
        // );
        // console.log(
        //   "RESPONSE PORTUGAL",
        //   res["Florestas de outros carvalhos"]["1"]
        //   // [
        //   //   "Absorción acumulada total (tCO₂)"
        //   // ]
        // );
        setCarbonResponse(res);
        function calcularDistribucionArea(clases) {
          const areas_ha = {};

          // Extraer el area_ha de cada clase (primer año válido)
          for (const [clase, años] of Object.entries(clases)) {
            const area = Object.values(años).find(
              (a) => a?.area_ha != null
            )?.area_ha;
            if (area != null) {
              areas_ha[clase] = area;
            }
          }

          const total_ha = Object.values(areas_ha).reduce(
            (acc, val) => acc + val,
            0
          );

          const distribucion = {
            "%": {},
            ha: {},
            m2: {},
            km2: {},
          };

          for (const [clase, area_ha] of Object.entries(areas_ha)) {
            distribucion["%"][clase] = area_ha / total_ha;
            distribucion["ha"][clase] = area_ha;
            distribucion["m2"][clase] = area_ha * 10_000;
            distribucion["km2"][clase] = area_ha / 100;
          }

          return distribucion;
        }
        setActualGroundUse(calcularDistribucionArea(res));
        // setActualGroundUse({ "%": calcularPorcentajePorClase(res) });
        // setActualGroundUse(res.ground_use_distribution);
        // setIsLoading(false);

        setAreaUnit(
          res.area_km2 > 1 ? "km2" : res.area_km2 * 100 > 1 ? "ha" : "m2"
        );
      } catch (error) {
        console.error("Error al procesar el área:", error);
        // Opcional: puedes mostrar un mensaje al usuario
        setCarbonResponse({});
        setActualGroundUse({});
        setEditedGeometry(null);
        toast.error(t("geometry_error"), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          // transition: Bounce,
        });
        onClose();
      } finally {
        setIsLoading(false);
      }
    };
    if (!editedGeometry) return;
    fetchData();
  }, [editedGeometry]);

  const handleChangeCategory = async (e) => {
    const newCategory = e?.target?.value;
    setCategory(newCategory);
    setIsLoading(true);
    const geometry = {
      coordinates: editedGeometry,
      type: "Polygon",
      // type: "MultiPolygon",
    };

    const res = await changeCategory(
      modeOptions.CARBON_SINK[0],
      geometry,
      newCategory
    );

    setCarbonResponse(res);
    setIsLoading(false);
  };

  const valuesOriginal = [
    carbonResponse.carbon_credits_tCO2e,
    carbonResponse.market_value_euros,
    carbonResponse.carbon_Mg,
    // response.market_value_euros_per_m2,
    // response.mean_carbon_MgHa,
  ];

  const valuesComparado = [
    carbonResponse.carbon_credits_tCO2e +
      carbonResponse.carbon_credits_tCO2e_diff,
    carbonResponse.market_value_euros + carbonResponse.market_value_euros_diff,
    carbonResponse.carbon_Mg + carbonResponse.carbon_Mg_diff,
    // response.market_value_euros_per_m2 + response.market_value_diff_euros_m2,
    // response.mean_carbon_MgHa + response.carbon_difference_MgHa,
  ];

  const normalizeRelativeToOriginal = (value, base) => {
    if (base === 0) return 0;
    return value / base;
  };

  const normalizedOriginal = [];
  const normalizedComparado = [];

  for (let i = 0; i < valuesOriginal.length; i++) {
    const base = valuesOriginal[i];
    normalizedOriginal.push(
      normalizeRelativeToOriginal(valuesOriginal[i], base)
    ); // será 1
    normalizedComparado.push(
      normalizeRelativeToOriginal(valuesComparado[i], base)
    ); // relativo
  }

  // console.log("ACA valuesOriginal", valuesOriginal);
  // console.log("ACA valuesComparado", valuesComparado);
  // console.log("ACA normalizedOriginal", normalizedOriginal);
  // console.log("ACA normalizedComparado", normalizedComparado);

  function hexToRGBA(hex, alpha = 0.2) {
    if (!hex) return "rgba(0, 0, 0, 0.2)";
    const r = parseInt(hex.substring(1, 3), 16);
    const g = parseInt(hex.substring(3, 5), 16);
    const b = parseInt(hex.substring(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  const originalColor = "#6a51a3";
  const originalColorRGBA = hexToRGBA(originalColor, 0.2);

  const colorHex = categoriesColors[category];
  const backgroundRGBA = hexToRGBA(colorHex, 0.2);
  const borderColor = colorHex || "rgb(54, 162, 235)";

  const radarData = {
    labels: [
      t("carbon_credits_tCO2e"),
      t("market_value_euros"),
      t("carbon_Mg"),
    ],
    datasets: [
      {
        label: t("Sin datos"),
        data: normalizedOriginal,
        fill: true,
        backgroundColor: originalColorRGBA,
        borderColor: originalColor,
        pointBackgroundColor: originalColor,
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: originalColor,
      },
      {
        label: t(category),
        data: normalizedComparado,
        fill: true,
        backgroundColor: backgroundRGBA,
        borderColor: borderColor,
        pointBackgroundColor: borderColor,
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: borderColor,
      },
    ],
  };

  // 1. Calcula el valor mínimo entre tus datasets
  const allValues = [...normalizedOriginal, ...normalizedComparado];
  const dataMin = Math.min(...allValues);
  const dataMax = Math.max(...allValues);
  const minValue = Math.min(0, dataMin); // valor mínimo entre 0 y el más pequeño
  const maxValue = Math.max(1, dataMax); // valor mínimo entre 0 y el más pequeño

  const radarOptions = {
    maintainAspectRatio: false,
    // responsive: true,
    plugins: {
      legend: {
        position: "right",
      },
      title: {
        display: true,
        text: t("new_ground_use_normalized_update"),
        color: "#333",
        align: "center", // 'center' o 'end' también válido
        font: {
          size: 14,
          weight: "bold",
        },
        // color: "#333",
        padding: {
          top: 10,
          bottom: 10,
        },
      },
    },
    scales: {
      r: {
        beginAtZero: false, // esto lo ignoramos porque vamos a poner el valor exacto
        min: minValue,
        max: maxValue, // ajusta si quieres un tope superior, o usa Math.max(...allValues)
        ticks: {
          stepSize: 0.2, // opcional: para control más fino de los ticks
        },
      },
    },
  };

  const groundUseLabels = Object.keys(actualGroundUse?.["%"] ?? []);
  console.log("dataaa", actualGroundUse);
  // console.log("actualGroundUse?.[ % ]", actualGroundUse?.["%"]);

  const groundUseData = {
    labels: groundUseLabels.map(
      (label) =>
        `${(actualGroundUse?.["%"][label] * 100).toFixed(0)}% - ${t(label)}`
    ),
    datasets: [
      {
        label: t(areaUnit),
        data: Object.values(actualGroundUse?.[areaUnit] ?? []),
        backgroundColor: groundUseLabels.map((label) =>
          categoriesColors[label] ? `${categoriesColors[label]}4D` : "#c8c8c84D"
        ),
        borderColor: groundUseLabels.map(
          (label) => categoriesColors[label] ?? "rgba(200,200,200,1)"
        ),
        borderWidth: 1,
      },
    ],
  };

  const groundUseOptions = {
    maintainAspectRatio: false,
    // responsive: true,
    plugins: {
      title: {
        display: true,
        text: t("actual_ground_use_distribution"),
        color: "#333",
        align: "center", // 'center' o 'end' también válido
        font: {
          size: 14,
          weight: "bold",
        },
        // color: "#333",
        padding: {
          top: 10,
          bottom: 10,
        },
      },
      legend: {
        position: "right",
        labels: {
          boxWidth: 50,
          padding: 15,
        },
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    // Puedes agregar layout para más control del espacio
    // layout: {
    //   padding: {
    //     right: 20,
    //   },
    // },
  };

  const handleCloseForm = () => {
    resetDrawingSession({ map: mapInstanceRef.current, setEditedGeometry });
    onClose();
  };

  useImperativeHandle(ref, () => ({
    function: handleCloseForm, // Evita la recursión
  }));

  const lineOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: t("carbon_quotes_graph_title"),
      },
    },
  };

  // const labels = [
  //   "January",
  //   "February",
  //   "March",
  //   "April",
  //   "May",
  //   "June",
  //   "July",
  // ];
  // const lineLabels = carbonQuotes?.map((el) => {
  //   const date = new Date(el.fx_value);
  //   const day = String(date.getDate()).padStart(2, "0"); // Añade cero si es menor de 10
  //   const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth es 0-indexado
  //   return `${day}-${month}`;
  // });
  const lineLabels = carbonQuotes?.map((el) => {
    const date = new Date(el.fx_value);
    const day = String(date.getDate()).padStart(2, "0");

    // Asume que tienes disponible la variable `i18n.language` con 'es', 'en', o 'pt'
    const monthShort = new Intl.DateTimeFormat(i18n.language, {
      month: "short",
    }).format(date);

    return `${day}-${monthShort}`;
  });

  const lineData = {
    labels: lineLabels,
    datasets: [
      {
        label: t("carbon_quote"),
        data: carbonQuotes?.map((el) => el.price_value),
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };

  const carbonResponseClassFiltered = Object.entries(carbonResponse).filter(
    ([_, speciesDict]) => {
      const hasValues = Object.values(speciesDict).some((yearDict) => {
        const parameters = [
          "Absorción acumulada (tCO2/ha)",
          "Absorción acumulada (tCO2/pie)",
          "Absorción acumulada total (tCO₂)",
          "carbon_credits_tCO2e_acumulados_constante",
          "carbon_credits_tCO2e_acumulados_optimista",
          "carbon_credits_tCO2e_acumulados_pesimista",
        ];
        return (
          typeof yearDict === "object" &&
          parameters.every(
            (param) => yearDict[param] != null && yearDict[param] !== 0
          )
          // yearDict.carbon_credits_tCO2e_acumulados_constante != null &&
          // yearDict.carbon_credits_tCO2e_acumulados_constante != 0
        );
      });
      return hasValues;
    }
  );

  const carbonCreditsPerYearByClassesData = {
    labels: Array.from({ length: 40 }, (_, i) => i + 1),
    datasets: carbonResponseClassFiltered.map(([speciesName, speciesDict]) => {
      return {
        label: t(speciesName),
        data: Object.entries(speciesDict).map(([_, yearDict]) => {
          return yearDict.carbon_credits_tCO2e_acumulados_constante > 0
            ? yearDict.carbon_credits_tCO2e_acumulados_constante
            : 0.0001;
        }),
        borderColor: categoriesColors[speciesName],
        backgroundColor: `${categoriesColors[speciesName]}55`,
      };
    }),
  };

  const pieHaRelationData = {
    // labels: carbonResponseClassFilter.map(([speciesName, speciesDict]) => {
    //   return Object.entries(speciesDict).map(([_, yearDict]) => {
    //     return yearDict["Absorción acumulada (tCO2/ha)"];
    //   });
    // }),
    datasets: carbonResponseClassFiltered.map(([speciesName, speciesDict]) => {
      return {
        label: t(speciesName),
        data: Object.entries(speciesDict).map(([_, yearDict]) => {
          return {
            x: yearDict["Absorción acumulada (tCO2/pie)"],
            y: yearDict["Absorción acumulada (tCO2/ha)"],
          };
          // return yearDict["Absorción acumulada (tCO2/ha)"] > 0
          //   ? yearDict["Absorción acumulada (tCO2/ha)"]
          //   : 0.0001;
        }),
        borderColor: categoriesColors[speciesName],
        backgroundColor: `${categoriesColors[speciesName]}55`,
      };
    }),
  };

  console.log("pieHaRelation", pieHaRelationData);

  const lineOptions2 = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: t("species_per_year_graph_title"),
      },
    },
    scales: {
      y: {
        type: "logarithmic",
        title: {
          display: true,
          text: t("accumulated_carbon_credits"),
          // text: "€",
        },
        ticks: {
          callback: function (value, index, values) {
            return Number(value).toLocaleString(); // Opcional: formatea valores
          },
        },
        min: 0.0001, // evita error por log(0)
      },
      x: {
        title: {
          display: true,
          text: "Año",
        },
      },
    },
  };

  const scatterOptions = {
    // scales: {
    //   y: {
    //     beginAtZero: true,
    //   },
    // },
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: t("relation_tCO2/pie_tCO2/ha"),
      },
    },
    scales: {
      y: {
        // type: "logarithmic",
        title: {
          display: true,
          text: "€ Carbon credits acumulados",
          // text: "€",
        },
        ticks: {
          callback: function (value, index, values) {
            return Number(value).toLocaleString(); // Opcional: formatea valores
          },
        },
        min: 0.0001, // evita error por log(0)
      },
      x: {
        title: {
          display: true,
          text: "Año",
        },
      },
    },
  };

  // console.log("lineData carbonQuotes", carbonQuotes);
  console.log("lineData1", lineData);
  console.log("lineData2", carbonCreditsPerYearByClassesData);

  return (
    <Box
      sx={{
        width: "100%",
        padding: "1rem",
        paddingBottom: "0",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
      }}
    >
      <div
        style={{
          flexGrow: "1",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          justifyContent: isLoading ? "center" : "flex-start",
        }}
      >
        {isLoading ? (
          <CircularProgress style={{ alignSelf: "center" }} />
        ) : (
          <>
            <div ref={carbonCategoryRef}>
              <TextField
                value={category ?? ""}
                onChange={handleChangeCategory}
                label={t("category")}
                fullWidth
                select
                variant="outlined"
              >
                {Object.entries(categoriesColors).map(([option, color]) => (
                  <MenuItem key={option} value={option}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {option === "Sin datos" ? (
                        <div
                          style={{
                            height: "1rem",
                            width: "1rem",
                            display: "grid",
                            gridTemplateColumns: "repeat(3, 1fr)",
                            gridTemplateRows: "repeat(3, 1fr)",
                            borderRadius: "4px",
                            overflow: "hidden",
                            marginRight: "0.5rem",
                          }}
                        >
                          {[
                            "#31a354",
                            "#31a354",
                            "#e34a33",
                            "#3182bd",
                            "#7fcdbb",
                            "#addd8e",
                            "#31a354",
                            "#addd8e",
                            "#e34a33",
                          ].map((c, i) => (
                            <div
                              key={i}
                              style={{
                                backgroundColor: c,
                                width: "100%",
                                height: "100%",
                              }}
                            />
                          ))}
                        </div>
                      ) : (
                        <div
                          style={{
                            height: "1rem",
                            width: "1rem",
                            backgroundColor: color ?? "transparent",
                            border: !color && "1px solid lightgrey",
                            borderRadius: "4px",
                            overflow: "hidden",
                            marginRight: "0.5rem",
                          }}
                        />
                      )}
                      {t(option)}
                    </div>
                  </MenuItem>
                ))}
              </TextField>
            </div>
            {/* AREA */}
            <CarbonFeatureSection title="area" icon={<MapIcon />}>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "space-around",
                  margin: "0.4rem",
                }}
              >
                {areaUnit === "m2" && (
                  <CustomTextField
                    field={"area_m2"}
                    value={carbonResponse.area_km2 * 1_000_000}
                    readOnly
                  />
                )}
                {areaUnit === "km2" && (
                  <CustomTextField
                    field={"area_km2"}
                    value={carbonResponse.area_km2}
                    readOnly
                  />
                )}
                {areaUnit === "ha" && (
                  <CustomTextField
                    field={"area_ha"}
                    value={carbonResponse.area_km2 * 100}
                    readOnly
                  />
                )}
                {/* <CustomTextField
                    field={`total_area_${areaUnit}`}
                    value={response[`total_area_${areaUnit}`]}
                    readOnly
                  /> */}

                {/* <ToggleButtonGroup
                    color="primary"
                    value={areaUnit}
                    exclusive
                    onChange={handleChangeAreaUnit}
                    aria-label="Platform"
                  >
                    <ToggleButton value="m2">m²</ToggleButton>
                    <ToggleButton value="km2">km²</ToggleButton>
                    <ToggleButton value="ha">ha</ToggleButton>
                  </ToggleButtonGroup> */}
              </div>
              <div style={{ height: "200px", minWidth: "550px" }}>
                <Pie
                  data={groundUseData}
                  options={groundUseOptions}
                  height={200}
                />
              </div>
            </CarbonFeatureSection>
            {/* MARKET VALUE */}
            <CarbonFeatureSection
              title="market_value"
              icon={<ForestIcon />}
              max_height="700px"
            >
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "space-around",
                  margin: "0.4rem 0",
                }}
              >
                <InputCard
                  title="actual_carbon_quote"
                  value={carbonQuotes?.[carbonQuotes.length - 1]?.price_value}
                  // diff_value={carbonResponse.market_value_euros_diff}
                />
              </div>
              <Line options={lineOptions} data={lineData} />
            </CarbonFeatureSection>
            <Line
              options={lineOptions2}
              data={carbonCreditsPerYearByClassesData}
            />
            {/* <Line options={lineOptions} data={pieHaRelation} /> */}
            <Scatter options={scatterOptions} data={pieHaRelationData} />
            {/* MARKET VALUE */}
            {/* <CarbonFeatureSection
              title="market_value"
              icon={<EuroIcon />}
              max_height="700px"
            >
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "space-around",
                  margin: "0.4rem 0",
                }}
              >
                <InputCard
                  title="market_value_euros"
                  value={carbonResponse.market_value_euros}
                  diff_value={carbonResponse.market_value_euros_diff}
                />
                <InputCard
                  title="market_value_euros_per_m2"
                  value={carbonResponse.market_value_euros_per_km2 / 1_000_000}
                  diff_value={
                    carbonResponse.market_value_euros_per_km2_diff / 1_000_000
                  }
                  decimals={4}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "space-around",
                  margin: "0.4rem 0",
                }}
              >
                <InputCard
                  title="actual_carbon_quote"
                  value={carbonQuotes?.[carbonQuotes.length - 1]?.price_value}
                  // diff_value={carbonResponse.market_value_euros_diff}
                />
              </div>
              <Line options={lineOptions} data={lineData} />
            </CarbonFeatureSection> */}
            {/* CARBON */}
            {/* <CarbonFeatureSection title="carbon_Mg" icon={<Co2Icon />}>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "space-around",
                  margin: "0.4rem 0",
                }}
              >
                <InputCard
                  title="carbon_Mg"
                  value={carbonResponse.carbon_Mg}
                  diff_value={carbonResponse.carbon_Mg_diff}
                />
              </div>
            </CarbonFeatureSection> */}
            {/* CARBON CREDITS */}
            {/* <CarbonFeatureSection
              title="carbon_credits"
              icon={<ShoppingCartIcon />}
            >
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "space-around",
                  margin: "0.4rem 0",
                }}
              >
                <InputCard
                  title="carbon_credits_tCO2e"
                  value={carbonResponse.carbon_credits_tCO2e}
                  diff_value={carbonResponse.carbon_credits_tCO2e_diff}
                />
                <InputCard
                  title="carbon_credits_tCO2e_per_km2"
                  value={carbonResponse.carbon_credits_tCO2e_per_km2}
                  diff_value={carbonResponse.carbon_credits_tCO2e_per_km2_diff}
                  decimals={4}
                />
              </div>
            </CarbonFeatureSection> */}
            {/* {category !== "Sin datos" && (
              <div style={{ height: "200px", minWidth: "550px" }}>
                <Radar data={radarData} options={radarOptions} />
              </div>
            )} */}
          </>
        )}
      </div>
    </Box>
  );
});

function CopyableText({ text, copyValue }) {
  const { t } = useTranslation("main");

  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(copyValue);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // vuelve a "Copiar" después de 2s
    } catch (err) {
      console.error("Error al copiar:", err);
    }
  };

  return (
    <MUITooltip title={copied ? t("copied") : t("copy")} followCursor>
      <div
        onClick={handleCopy}
        style={{
          cursor: "pointer",
        }}
      >
        {text}
      </div>
    </MUITooltip>
  );
}

const CustomTextField = ({
  field,
  value,
  options,
  onChange,
  readOnly,
  link,
  disableClear,
  ...rest
}) => {
  const { t } = useTranslation("main");
  const isSelect = Array.isArray(options) && options.length > 0;

  if (!value) return;

  const val = new Intl.NumberFormat("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value?.toFixed(2));

  return (
    <TextField
      {...rest}
      value={
        Object.keys(units).includes(field) ? `${val} ${units[field]}` : val
      }
      onChange={(e) => {
        if (onChange) onChange(field)(e);
      }}
      // label={readOnly ? `${t(field)} (${t("read_only")})` : t(field)}
      label={t(field)}
      // fullWidth
      select={isSelect} // Solo es select si hay opciones
      InputProps={{
        endAdornment: val && !readOnly && !disableClear && (
          <InputAdornment
            position="end"
            style={{ marginRight: isSelect ? "20px" : "" }}
          >
            <IconButton
              onClick={() => onChange(field)("")}
              size="small"
              style={{
                width: "0.9rem",
                height: "0.9rem",
              }}
            >
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
      variant={readOnly ? "standard" : "outlined"}
      sx={{
        "& .MuiInputBase-inputAdornedEnd": {
          paddingRight: "0!important", // Cambia esto a la propiedad que quieras modificar
        },
      }}
      multiline
    >
      {isSelect
        ? options.map((option) => (
            <MenuItem key={option} value={option}>
              {t(option)}
            </MenuItem>
          ))
        : null}
    </TextField>
  );
};

export const InputCard = ({ title, value, diff_value, decimals = 2 }) => {
  const { t } = useTranslation("main");

  const principalValue = diff_value ? value + diff_value : value;

  const secondaryValue = diff_value ? diff_value : null;
  // const isMore = secondaryValue > 0;

  const formatNumber = (val) => {
    console.log("formatNumber", val, typeof val);
    return new Intl.NumberFormat("es-ES", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(val?.toFixed(decimals));
  };

  return (
    <Paper
      elevation={3}
      style={{
        padding: "1rem",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      <div style={{ whiteSpace: "nowrap" }}>{t(title)}</div>
      <div
        style={{
          display: "flex",
          fontSize: "1.5rem",
          alignSelf: "flex-end",
          alignItems: "center",
          color: secondaryValue
            ? secondaryValue < 0
              ? "red"
              : secondaryValue > 0
                ? "green"
                : ""
            : "",
          // gap: "1rem",
          whiteSpace: "nowrap",
        }}
      >
        {secondaryValue &&
          (secondaryValue < 0 ? (
            <ArrowDropDownIcon
              style={{
                color: "red",
              }}
            />
          ) : (
            <ArrowDropUpIcon
              style={{
                color: "green",
              }}
            />
          ))}
        {/* <div> */}
        <CopyableText
          text={
            Object.keys(units).includes(title)
              ? `${formatNumber(principalValue)} ${units[title]}`
              : formatNumber(principalValue)
          }
          copyValue={principalValue}
        />
        {/* </div> */}
      </div>
      <div
        style={{
          display: "flex",
          fontSize: "0.75rem",
          alignSelf: "flex-end",
        }}
      >
        {secondaryValue > 0 && "+"}
        <CopyableText
          text={
            secondaryValue
              ? Object.keys(units).includes(title)
                ? `${formatNumber(secondaryValue)} ${units[title]}`
                : formatNumber(secondaryValue)
              : // : "\u00A0"
                ""
          }
          copyValue={secondaryValue}
        />
      </div>
    </Paper>
  );
};

export const CarbonFeatureSection = ({ title, icon, children, max_height }) => {
  const { t } = useTranslation("main");

  const [showMore, setShowMore] = useState(true);

  const toggleSection = () => setShowMore((prev) => !prev);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      <div
        style={{
          cursor: "pointer",
          width: "100%",
          display: "flex",
          gap: "1rem",
          alignItems: "center",
        }}
        onClick={toggleSection}
      >
        {icon}
        <Typography>{t(title)}</Typography>
        <Divider
          style={{
            flexGrow: "1",
          }}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {showMore ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          overflow: "hidden",
          maxHeight: showMore ? (max_height ?? "300px") : "0px",
          transition: "max-height 0.5s ease",
          // margin: "1rem 0",
        }}
      >
        {children}
      </div>
    </div>
  );
};
